import {
  ClearwaterTransaction,
  ExternalTransaction,
  ExternalTransactionStatus,
} from '@helios/common-api'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const filterFeatureKey = 'filters'

export type ExtTranIdSourceType = 'clearwater' | 'external'

export type FilterRedux = {
  transactions: {
    securityId?: number
    currencyCode?: string
    extTranIds?: Array<number | undefined>
    extTranIdSource?: ExtTranIdSourceType
  }
}

export const filterInitialState: FilterRedux = {
  transactions: {
    securityId: undefined,
    currencyCode: undefined,
    extTranIds: undefined,
    extTranIdSource: undefined,
  },
}

export const filterSlice = createSlice({
  name: filterFeatureKey,
  initialState: filterInitialState,
  reducers: {
    setTransactionSecurityId: (
      oldState,
      action: PayloadAction<number | undefined>,
    ) => ({
      ...oldState,
      transactions: {
        ...oldState.transactions,
        securityId: action.payload,
        currencyCode: '',
      },
    }),

    setTransactionCurrencyCode: (
      oldState,
      action: PayloadAction<string | undefined>,
    ) => ({
      ...oldState,
      transactions: {
        ...oldState.transactions,
        currencyCode: action.payload,
        securityId: undefined,
      },
    }),

    setExtTranIdsFilter: (
      oldState,
      action: PayloadAction<{
        extTranIds: Array<number | undefined>
        extTranIdSource: ExtTranIdSourceType | undefined
      }>,
    ) => ({
      ...oldState,
      transactions: {
        ...oldState.transactions,
        extTranIds: action.payload.extTranIds,
        extTranIdSource: action.payload.extTranIdSource,
      },
    }),

    setMatchedExtTransFilter: (
      oldState,
      action: PayloadAction<Array<ClearwaterTransaction>>,
    ) => {
      const extTranIds = action.payload.map(tx => tx.extTranIds ?? []).flat()
      return {
        ...oldState,
        transactions: {
          ...oldState.transactions,
          extTranIds,
          extTranIdSource: 'clearwater',
        },
      }
    },

    setMatchedCwTransFilter: (oldState, action: PayloadAction<number[]>) => {
      return {
        ...oldState,
        transactions: {
          ...oldState.transactions,
          extTranIds: action.payload.slice(),
          extTranIdSource: 'external',
        },
      }
    },

    clearFilters: state => ({
      ...state,
      ...filterInitialState,
    }),
  },
})

export const {
  setTransactionSecurityId,
  setTransactionCurrencyCode,
  setExtTranIdsFilter,
  setMatchedExtTransFilter,
  setMatchedCwTransFilter,
  clearFilters,
} = filterSlice.actions

export default filterSlice.reducer
